import {
  AnswerOption,
  Cards,
  CourseChapter,
  CourseModuleCards,
  Question,
} from "@mikros/library";
import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { Button } from "@progress/kendo-react-buttons";
import { GeneratedChapter } from "./gneratedChapter";
import { Error } from "@progress/kendo-react-labels";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Confirm } from "../confirm";
import { useNavigate } from "react-router-dom";
import { Alert } from "../alert";
import { FormattedMessage, useIntl } from "react-intl";
import {
  Sortable,
  SortableItemUIProps,
  SortableOnDragOverEvent,
  SortableOnNavigateEvent,
} from "@progress/kendo-react-sortable";
import Utils from "../utils";
import { GeneratedChapterEdit } from "./generatedChapterEdit";
import { TestCourseDialog } from "../testCourseDialog";
import { Loading } from "../loading";
import { Tooltip } from "@mui/material";
import { Box } from "@mui/joy";

export interface GenerateCourseChaptersCards {
  cards: CourseModuleCards;
  specificCreateCourseFunction?: (e: CourseModuleCards) => Promise<boolean>;
  handleUploadGiveUrl?: (e: CourseModuleCards) => void;
  handleVideoGeneration?: (e: any) => Promise<string | false>;
  handleImageGeneration?: (e: any) => Promise<string | false>;
  // handleAudioGeneration?:(e:any)=>Promise<string|false>;
    handleAudioGeneration?: (e: any) => Promise<{ presignedUrl: string; prompt: string } | false>;
  duplicateS3File?: (
    sourceKey: string,
    destinationKey: string,
    fileType: string
  ) => void;
  isManual: boolean;
  isCourse?: boolean;
  tenantRole?: string;
  handleUpdateStatusRev?: (
    status: string,
    course: CourseModuleCards,
    unpublish?: boolean
  ) => Promise<boolean>;
  handleUpdateStatusAll?: (
    status: string,
    course: CourseModuleCards
  ) => Promise<boolean>;
  oneChapterDeleteFunction?: Function;
  testCourse?: any;
  videoGeneratingCardIds?: Set<string>;
  setVideoGeneratingCardIds?: (cardId: string | null) => void;
  onCourseDetailsRefresh?: () => Promise<void>;
}

export function GenerateCourseChaptersCards(
  props: GenerateCourseChaptersCards
) {
  const intl = useIntl();
  let utils = new Utils();
  const navigate = useNavigate();

  const [clickQuickSave, setClickQuickSave] = useState<boolean>(false);
  const [course, setCourse] = useState<CourseModuleCards>(props.cards);
  const [oneChapterDelete, setOneChapterDelete] = useState<boolean>(false);
  const [duplicateLoader, setDuplicateLoader] = useState<boolean>(false);
  const [courseWarningDialogue, setCourseWarningDialogue] =
    useState<boolean>(false);

  console.log(
    "video generating card ids in generate chapter cards",
    props.videoGeneratingCardIds
  );
  console.log("course chapter in generate chapter cards", course?.chapters);
  console.log("course chapter count", course?.chapters?.length);
  console.log(
    "one chapter delte bool value in generate chapter cards",
    oneChapterDelete
  );
  console.log("course id in gen chapt cards", course.courseId);
  console.log("course print gen chapt", course);
  console.log("click quick save", clickQuickSave);

  // Log URL fields from all course chapters and cards
  if (course?.chapters) {
    course.chapters.forEach((chapter: any, chapterIndex: number) => {
      console.log(
        `Chapter ${chapterIndex + 1} (${chapter.chapterName}) URL fields:`,
        {
          chapterId: chapter.chapterId,
          chapterName: chapter.chapterName,
        }
      );

      if (chapter.cards) {
        chapter.cards.forEach((card: any, cardIndex: number) => {
          console.log(
            `  Chapter ${chapterIndex + 1} Card ${cardIndex + 1} URL field:`,
            {
              cardId: card.cardId,
              url: card.url,
              cardInfo: card.cardInfo,
              cardType: card.cardType,
            }
          );
          console.log(
            `  Chapter ${chapterIndex + 1} Card ${
              cardIndex + 1
            } presigned url:`,
            card.url
          );
        });
      }
    });
  }
  const [copyCourse, setCopyCourse] = useState<CourseModuleCards>(
    utils.deepCopy(props.cards)
  );
  const [loader, setLoader] = React.useState<boolean>(false);

  console.log("print tenant role received from props", props.tenantRole);

  const getObjectNotFoundUrl = (): boolean => {
    console.log("inside get object not found url");
    if (!course.chapters) return false;

    for (const chapter of course.chapters) {
      for (const card of chapter.cards || []) {
        const cardUrl = card.url;
        console.log(
          "card url inside get object not found url of generateChaptersCards print pleaseee",
          cardUrl
        );

        if (cardUrl === "" || cardUrl?.includes("object not found")) {
          return true;
        }
      }
    }
    return false;
  };

  // Check if this course has empty URLs
  const hasEmptyUrl = getObjectNotFoundUrl();

  console.log("has empty url inside generateChaptersCards", hasEmptyUrl);

  // this state is only for editable and it's inside handle
  const [makeChapterEditable, setMakeChapterEditable] =
    useState<boolean>(false);
  const [editableChpt, setEditableChpt] = useState<CourseChapter>(
    {} as CourseChapter
  );

  // this is for under sortables
  const [courseChapters, setCourseChapters] = useState<Array<object>>(
    props.cards.chapters
  );
  const [enableDrag, setEnableDrag] = useState<boolean>(
    course.status === "PUBLISHED" ? false : true
  );
  // for duplicate chapter
  const [dupChptReq, setDupChptReq] = useState<boolean>(false);
  const [orgChptForDup, setOrgChptForDup] = useState<CourseChapter>(
    {} as CourseChapter
  );
  // for deleting chapter
  const [delChptReq, setDelChptReq] = useState<boolean>(false);
  const [orgDelChpt, setOrgDelChpt] = useState<CourseChapter>(
    {} as CourseChapter
  );

  // Just dialogue
  const [formDialog, setformDialog] = React.useState<boolean>(false);
  const [formCourseDialog, setformCourseDialog] =
    React.useState<boolean>(false);
  const [quickSaveDialog, setQuickSaveDialog] = useState<boolean>(false);
  const [publishDialog, setPublishDialog] = useState<boolean>(false);
  const [successPublishDialog, setSuccessPublishDialog] =
    useState<boolean>(false);
  const [rejectDialog, setRejectDialog] = useState<boolean>(false);
  const [successRejectDialog, setSuccessRejectDialog] =
    useState<boolean>(false);
  const [submitDialog, setSubmitDialog] = useState<boolean>(false);
  const [successSubmitDialog, setSuccessSubmitDialog] =
    useState<boolean>(false);
  const [unpublishDialog, setUnpublishDialog] = useState<boolean>(false);
  const [unpublishSuccessDialog, setUnpublishSuccessDialog] =
    useState<boolean>(false);
  //error
  const [error, setError] = useState<any>({} as any);
  const [testCourseDialog, setTestCourseDialog] = useState<boolean>(false);

  console.log(
    "quick save dialog state in generate chapter cards",
    quickSaveDialog
  );

  console.log("enable drag value in generatechapters cards", enableDrag);
  console.log("test course dialog state", testCourseDialog);
  console.log("submit success dialog print", successSubmitDialog);

  const deepCopyCompareFunction = (): boolean => {
    // Create deep copies without updatedAt and url fields
    const cleanObject = (obj: CourseModuleCards) => {
      const cleaned = utils.deepCopy(obj) as CourseModuleCards;

      // Create new object without the fields we want to exclude
      const cleanedObj = {
        ...cleaned,
        chapters: cleaned.chapters.map((chapter) => ({
          ...chapter,
          url: undefined,
          updatedAt: undefined,
          cards: chapter.cards.map((card) => ({
            ...card,
            url: undefined,
            updatedAt: undefined,
          })),
        })),
      };

      return cleanedObj;
    };

    const newCourse = cleanObject(course);
    const newCopyCourse = cleanObject(copyCourse);

    console.log("new course value in generate chapter cards", newCourse);
    console.log(
      "new copy course value in generate chapter cards",
      newCopyCourse
    );
    console.log(
      "value compare in generate chapter cards",
      JSON.stringify(newCourse) === JSON.stringify(newCopyCourse)
    );
    // Compare stringified versions
    return JSON.stringify(newCourse) === JSON.stringify(newCopyCourse);
  };

  const toggleUnpublishDialog = () => {
    setUnpublishDialog(!unpublishDialog);
  };

  const handleConfirmYes = async () => {
    console.log("inside save dialog yes");
    const saveDraftButton = document.getElementById("saveDraftButton");
    console.log("print save draft button", saveDraftButton);
    if (saveDraftButton!!) {
      saveDraftButton.click();
    }
  };

  const handleSaveBeforeBack = async () => {
    console.log("inside save dialog yes");
    if (validate()) {
      let dt = { ...course };
      dt.chapters.map((chpt) => {
        delete chpt.newChapter;
        chpt.cards.map((card) => {
          delete card.cardInfo.card[0].tempUrl;
        });
      });

      if (props.specificCreateCourseFunction) {
        const saved = await props.specificCreateCourseFunction(course);
        if (saved) {
          setCopyCourse(utils.deepCopy(course));
        } else {
        }
      }
    }
  };

  const onDragOver = (event: SortableOnDragOverEvent) => {
    let data = course;
    data.chapters = event.newState as CourseChapter[];
    setCourseChapters(data.chapters);
    setCourse(data);
  };
  const onNavigate = (event: SortableOnNavigateEvent) => {
    console.log("this is navigate", event.newState);
    let data = course;
    data.chapters = event.newState as CourseChapter[];
    setCourseChapters(data.chapters);
    setCourse(data);
  };

  const getChapterIndex = (chapterId: string) => {
    return (
      course.chapters.findIndex((chapter) => chapter.chapterId === chapterId) +
      1
    );
  };

  // const handleDuplicateChapter = async (chapter: CourseChapter) => {
  //   const date = new Date().toISOString();
  //   const newChapterId = uuidv4();

  //   // Create duplicate chapter with basic properties
  //   const duplicateChapter: CourseChapter = {
  //     ...chapter,
  //     isTemprory: true,
  //     isLastChapter: false,
  //     seqNo: course.chapters.length + 1,
  //     chapterId: newChapterId,
  //     createdAt: date,
  //     updatedAt: date,
  //     date: date,
  //     chapterName: checkChapterName(chapter.chapterName),
  //   };

  //   // Duplicate cards
  //   const duplicatedCards: Cards[] = [];

  //   for (const orgCard of chapter.cards) {
  //     const cardId = uuidv4();
  //     let newUrl = "";
  //     let newPresignedUrl = "";

  //     if (orgCard.cardInfo.card[0].url) {
  //       const oldFilePathUrl = orgCard.cardInfo.card[0].url;
  //       const fileExt = oldFilePathUrl.split("/").pop()?.split(".").pop() || "";
  //       newUrl = `Mikros-Cards/acct-${course.accntId}/crse-${course.courseId}/chptr-${newChapterId}/card-${cardId}/${cardId}.${fileExt}`;

  //       if (props.duplicateS3File) {
  //         const result = await props.duplicateS3File(
  //           oldFilePathUrl,
  //           newUrl,
  //           orgCard.cardInfo.card[0].fileType
  //         );
  //         // Cast to unknown first before string to handle void return type
  //         newPresignedUrl = result as unknown as string;
  //       }
  //     }

  //     const duplicatedCard: Cards = {
  //       ...orgCard,
  //       isLastCard: false,
  //       createdAt: date,
  //       cardId,
  //       chapterId: newChapterId,
  //       date,
  //       updatedAt: date,
  //       cardInfo: {
  //         ...orgCard.cardInfo,
  //         cardId,
  //         card: [
  //           {
  //             language: orgCard.cardInfo.card[0].language,
  //             text: orgCard.cardInfo.card[0].text,
  //             fileType: newUrl ? newUrl.split("/").pop() || "txt" : "txt",
  //             url: newUrl,
  //           },
  //         ],
  //       },
  //       url: newPresignedUrl,
  //     };

  //     duplicatedCards.push(duplicatedCard);
  //   }

  //   duplicateChapter.cards = duplicatedCards;

  //   // Duplicate questions
  //   duplicateChapter.questions =
  //     chapter.questions?.map((oldQues) => ({
  //       ...oldQues,
  //       chapterId: newChapterId,
  //       quesId: uuidv4(),
  //       date,
  //       updatedAt: date,
  //       recType: `Question_${uuidv4()}`,
  //     })) || [];

  //   // Update course chapters
  //   const updatedChapters = [...course.chapters];
  //   const index = updatedChapters.findIndex(
  //     (ele) => ele.chapterId === chapter.chapterId
  //   );
  //   updatedChapters.splice(index + 1, 0, duplicateChapter);

  //   // Update sequence numbers
  //   updatedChapters.forEach((ch, idx) => {
  //     ch.seqNo = idx + 1;
  //   });

  //   setCourseChapters(updatedChapters);
  //   setCourse({
  //     ...course,
  //     chapters: updatedChapters,
  //     chapterCount: updatedChapters.length,
  //   });
  // };

  //taking a lot of time for duplicating media cards
  const handleDuplicateChapter = async (chapter: CourseChapter) => {
    // Show loader while duplicating chapter
    // setLoader(true);
    setDuplicateLoader(true);
    try {
      const date = new Date().toISOString();
      const newChapterId = uuidv4();

      // Create duplicate chapter with basic properties
      const duplicateChapter: CourseChapter = {
        ...chapter,
        isTemprory: true,
        isLastChapter: false,
        seqNo: course.chapters.length + 1,
        chapterId: newChapterId,
        createdAt: date,
        updatedAt: date,
        date: date,
        chapterName: checkChapterName(chapter.chapterName),
      };

      // Duplicate cards
      const duplicatedCards: Cards[] = [];

      for (const orgCard of chapter.cards) {
        const cardId = uuidv4();
        let newUrl = "";
        let newPresignedUrl = "";

        // Only generate new url if original card has a url field
        const hasUrl = !!orgCard.cardInfo.card[0].url;

        if (hasUrl) {
          const oldFilePathUrl = orgCard.cardInfo.card[0].url;
          const urlWithoutQuery = oldFilePathUrl.split("?")[0];
          const filename = urlWithoutQuery.split("/").pop() || "";
          const fileExt = filename.split(".").pop() || "";
          const newFileName = `${cardId}.${fileExt}`;
          newUrl = `Mikros-Cards/acct-${course.accntId}/crse-${course.courseId}/chptr-${newChapterId}/card-${cardId}/${newFileName}`;
          console.log("Duplicate chapter card URL", {
            oldFilePathUrl,
            urlWithoutQuery,
            filename,
            fileExt,
            newFileName,
            newUrl,
          });

          if (props.duplicateS3File) {
            const result = await props.duplicateS3File(
              oldFilePathUrl,
              newUrl,
              orgCard.cardInfo.card[0].fileType
            );
            // Cast to unknown first before string to handle void return type
            newPresignedUrl = result as unknown as string;
          }
        }

        // Build the duplicated cardInfo.card[0] object, preserving structure
        const originalCard0 = orgCard.cardInfo.card[0];
        let duplicatedCard0: typeof originalCard0;

        if (hasUrl) {
          // If original had url, set url and fileType as before
          duplicatedCard0 = {
            ...originalCard0,
            fileType: newUrl ? newUrl.split("/").pop() || "txt" : "txt",
            url: newUrl,
          };
        } else {
          // If original had no url, do not add url or fileType fields not present in original
          // Only copy the fields that exist in the original
          // (If fileType is present in original, keep it; if not, don't add)
          duplicatedCard0 = { ...originalCard0 };
          // Remove url and fileType if they were not present in the original
          if (!("url" in originalCard0)) {
            delete (duplicatedCard0 as any).url;
          }
          if (!("fileType" in originalCard0)) {
            delete (duplicatedCard0 as any).fileType;
          }
        }

        // Build duplicated cardInfo
        const duplicatedCardInfo = {
          ...orgCard.cardInfo,
          cardId,
          card: [duplicatedCard0],
        };

        // Build duplicated card object
        const duplicatedCard: Cards = {
          ...orgCard,
          isLastCard: false,
          createdAt: date,
          cardId,
          chapterId: newChapterId,
          date,
          updatedAt: date,
          cardInfo: duplicatedCardInfo,
          // Only add url field if original card had url
          ...(hasUrl
            ? { url: newPresignedUrl }
            : (() => {
                // If original card did not have url, do not add url field at all
                const { url, ...rest } = orgCard as any;
                return rest;
              })()),
        };

        duplicatedCards.push(duplicatedCard);
      }

      duplicateChapter.cards = duplicatedCards;

      // Duplicate questions
      duplicateChapter.questions =
        chapter.questions?.map((oldQues) => ({
          ...oldQues,
          chapterId: newChapterId,
          quesId: uuidv4(),
          date,
          updatedAt: date,
          recType: `Question_${uuidv4()}`,
        })) || [];

      // Update course chapters
      const updatedChapters = [...course.chapters];
      const index = updatedChapters.findIndex(
        (ele) => ele.chapterId === chapter.chapterId
      );
      updatedChapters.splice(index + 1, 0, duplicateChapter);

      // Update sequence numbers
      updatedChapters.forEach((ch, idx) => {
        ch.seqNo = idx + 1;
      });

      setCourseChapters(updatedChapters);
      setCourse({
        ...course,
        chapters: updatedChapters,
        chapterCount: updatedChapters.length,
      });
    } finally {
      // Hide loader after duplication is done (success or error)
      // setLoader(false);
      setDuplicateLoader(false);
    }
  };

  const handleAddNewChapter = () => {
    if (course.courseName === "" || course.description === "") {
      console.log("Inside the course name empty of generateChaptersCards");
      setCourseWarningDialogue(true);
      return;
    }
    const date = new Date();
    const chapterId = uuidv4();
    const entityId = uuidv4();
    const recType = uuidv4();
    const cardId = uuidv4();

    // Create default answer options
    const answers: AnswerOption[] = ["A", "B", "C", "D"].map((label) => ({
      optionLabel: label,
      optionFlag: "INCORRECT",
      optionVal: undefined,
      optionId: uuidv4(),
      optionRationale: "",
    }));

    // Create new chapter
    const newChapter: CourseChapter = {
      isTemprory: true,
      isLastChapter: false,
      seqNo: course.chapters.length + 1,
      entityId,
      status: course.status,
      createdAt: date.toISOString(),
      createdBy: course.createdBy,
      chapterId,
      date: date.toISOString(),
      chapterName: "",
      recType,
      updatedAt: date.toISOString(),
      courseId: course.courseId,
      description: "",
      entryType: course.entryType,
      courseName: course.courseName,
      newChapter: true,
      cards: [
        {
          isLastCard: false,
          seqNo: 1,
          entityId,
          status: course.status,
          createdAt: date.toISOString(),
          cardType: "TEXT",
          createdBy: course.createdBy,
          cardId,
          chapterId,
          date: date.toISOString(),
          chapterName: "",
          recType,
          updatedAt: date.toISOString(),
          courseId: course.courseId,
          description: "",
          entryType: "CARD",
          cardInfo: {
            cardType: "TEXT",
            card: [
              {
                language: "ENGLISH",
                text: "",
                fileType: "txt",
                url: "",
              },
            ],
            cardId,
          },
          cardName: "card" + course.chapters.length,
          courseName: course.courseName,
        },
      ],
      questions: [],
    };

    // Update course chapters
    const updatedCourse = { ...course };
    if (course.chapters.length > 0) {
      if (course.chapters[0].entityId) {
        updatedCourse.chapters.push(newChapter);
      } else {
        newChapter.isLastChapter = true;
        updatedCourse.chapters[0] = newChapter;
      }
    }
    updatedCourse.chapterCount = updatedCourse.chapters.length;

    setCourse(updatedCourse);
    setCourseChapters(updatedCourse.chapters);
    setEditableChpt(newChapter);
    setMakeChapterEditable(true);
  };

  const checkChapterName = (name: string): string => {
    let cname = name;
    const flag = true;
    let count = 0;
    while (flag) {
      const check = course.chapters.find((ele) => ele.chapterName === cname);
      if (check) {
        count++;
        cname = name + count;
      } else {
        return cname;
      }
    }
    return cname;
  };

  //when no media cards, url should not be added, here it is adding
  // const handleDeleteChapter = (chapterId: string) => {
  //   const updatedCourse = { ...course };
  //   const remainingChapters = updatedCourse.chapters.filter(
  //     (ele) => ele.chapterId !== chapterId
  //   );

  //   // Create sample chapter if no chapters remain
  //   if (remainingChapters.length === 0) {
  //     const date = new Date().toISOString();
  //     const newChapterId = uuidv4();

  //     remainingChapters.push({
  //       isTemprory: true,
  //       isLastChapter: false,
  //       seqNo: 1,
  //       entityId: uuidv4(),
  //       status: course.status,
  //       createdAt: date,
  //       createdBy: course.createdBy,
  //       chapterId: newChapterId,
  //       date: date,
  //       chapterName: intl.formatMessage({
  //         id: "courses.createCourse.chapterName",
  //       }),
  //       recType: `Sample_Chapter_${uuidv4()}`,
  //       updatedAt: date,
  //       courseId: course.courseId,
  //       description: intl.formatMessage({
  //         id: "courses.createCourse.sampleChaptDesc",
  //       }),
  //       entryType: course.entryType,
  //       courseName: course.courseName,
  //       cards: [
  //         {
  //           isLastCard: false,
  //           seqNo: 1,
  //           entityId: uuidv4(),
  //           status: "ACTIVE",
  //           createdAt: date,
  //           cardType: "TEXT",
  //           createdBy: course.createdBy,
  //           cardId: uuidv4(),
  //           chapterId: newChapterId,
  //           date: date,
  //           chapterName: intl.formatMessage({
  //             id: "courses.createCourse.chapterName",
  //           }),
  //           recType: `Card_${uuidv4()}`,
  //           updatedAt: date,
  //           courseId: course.courseId,
  //           description: "",
  //           entryType: course.entryType,
  //           cardInfo: {
  //             cardType: "TEXT",
  //             card: [
  //               {
  //                 language: "ENGLISH",
  //                 text: intl.formatMessage({
  //                   id: "courses.createCourse.sampleText",
  //                 }),
  //                 fileType: "txt",
  //                 url: "",
  //               },
  //             ],
  //             cardId: uuidv4(),
  //           },
  //           cardName: intl.formatMessage({
  //             id: "courses.createCourse.sampleCard",
  //           }),
  //           courseName: course.courseName,
  //           url: "",
  //         },
  //       ],
  //       questions: [],
  //     });
  //   }

  //   // Update state
  //   updatedCourse.chapters = remainingChapters;
  //   setCourseChapters(remainingChapters);
  //   setCourse(updatedCourse);
  // };

  const handleDeleteChapter = (chapterId: string) => {
    const updatedCourse = { ...course };
    const remainingChapters = updatedCourse.chapters.filter(
      (ele) => ele.chapterId !== chapterId
    );

    // Create sample chapter if no chapters remain
    if (remainingChapters.length === 0) {
      const date = new Date().toISOString();
      const newChapterId = uuidv4();

      remainingChapters.push({
        isTemprory: true,
        isLastChapter: false,
        seqNo: 1,
        entityId: uuidv4(),
        status: course.status,
        createdAt: date,
        createdBy: course.createdBy,
        chapterId: newChapterId,
        date: date,
        chapterName: intl.formatMessage({
          id: "courses.createCourse.chapterName",
        }),
        recType: `Sample_Chapter_${uuidv4()}`,
        updatedAt: date,
        courseId: course.courseId,
        description: intl.formatMessage({
          id: "courses.createCourse.sampleChaptDesc",
        }),
        entryType: course.entryType,
        courseName: course.courseName,
        cards: [
          {
            isLastCard: false,
            seqNo: 1,
            entityId: uuidv4(),
            status: "ACTIVE",
            createdAt: date,
            cardType: "TEXT",
            createdBy: course.createdBy,
            cardId: uuidv4(),
            chapterId: newChapterId,
            date: date,
            chapterName: intl.formatMessage({
              id: "courses.createCourse.chapterName",
            }),
            recType: `Card_${uuidv4()}`,
            updatedAt: date,
            courseId: course.courseId,
            description: "",
            entryType: course.entryType,
            cardInfo: {
              cardType: "TEXT",
              card: [
                {
                  language: "ENGLISH",
                  text: intl.formatMessage({
                    id: "courses.createCourse.sampleText",
                  }),
                  fileType: "txt",
                  url: "",
                },
              ],
              cardId: uuidv4(),
            },
            cardName: intl.formatMessage({
              id: "courses.createCourse.sampleCard",
            }),
            courseName: course.courseName,
            // url: "",
            url: "undefined",
          },
        ],
        questions: [],
      });
    }

    // Update state
    updatedCourse.chapters = remainingChapters;
    setCourseChapters(remainingChapters);
    setCourse(updatedCourse);
  };

  const toggleTestCourseDialog = () => {
    console.log("Inside toggleTestCourseDialog of gen chapt cards");
    setTestCourseDialog(true);
  };

  const handleUpdateChapter = (chapter: CourseChapter, isSave: boolean) => {
    console.log("This is the cancel chapter", chapter);
    console.log("isNewChapter", chapter.newChapter);
    console.log("isSave", isSave);

    if (chapter.newChapter && isSave === false) {
      console.log("entered inside isSave return");
      let dt = { ...course };
      dt.chapters.splice(dt.chapters.length - 1, 1);
      setCourseChapters(dt.chapters);
      setCourse(dt);
      setMakeChapterEditable(false);
      setEditableChpt({} as CourseChapter);
      return;
    }
    if (chapter.newChapter) {
      delete chapter.newChapter;
    }

    console.log("Updating chapter from Edit chapter", chapter.chapterId);
    let dt = course;
    let chptArray = [];
    for (let chpt of course.chapters) {
      if (chapter.chapterId === chpt.chapterId) {
        console.log("inside if of update");
        chptArray.push(chapter);
      } else {
        console.log("inside else of update");
        chptArray.push(chpt);
      }
    }

    dt.chapters = chptArray;
    setCourseChapters(dt.chapters);
    setCourse(dt);

    console.log("This is the course", dt);

    // update chapter is being called at both save and cancel events of edit chapter, so editable of the chapter and the particular edit chapter is set here.
    setMakeChapterEditable(false);
    setEditableChpt({} as CourseChapter);
  };

  const validate = (): boolean => {
    for (const element of course.chapters) {
      const check = course.chapters.find(
        (ele) =>
          ele.chapterName === element.chapterName &&
          ele.chapterId !== element.chapterId
      );
      if (check) {
        let err = error;
        err = {
          chapterName: {
            error: intl.formatMessage({
              id: "courses.generatedChaptCards.chapterUnique",
            }),
          },
        };
        setError(err);
        return false;
      }
    }
    let err = {};
    setError(err);
    return true;
  };

  const validateAndSubmit = async (): Promise<boolean> => {
    if (validate()) {
      let dt = { ...course };

      dt.chapters.map((chpt) => {
        delete chpt.newChapter;
        chpt.cards.map((card) => {
          delete card.cardInfo.card[0].tempUrl;
        });
      });

      console.log("course id before save draft", dt?.courseId);
      console.log("course before save draft", course);

      if (props.specificCreateCourseFunction) {
        const saved = await props.specificCreateCourseFunction(course);
        return saved;
      }
      return false;
    }
    return false;
  };

  useEffect(() => {
    setCourse(props.cards);
    setCourseChapters(props.cards.chapters);
  }, [props.cards]);

  return (
    <div className="flex flex-col space-y-4 pb-[20%]">
      {loader && (
        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-50 z-20">
          <Loading></Loading>
        </div>
      )}
      {duplicateLoader && (
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 z-20">
          <Loading></Loading>
        </div>
      )}
      <div className="w-full flex items-center justify-end">
        {/* Add new Chapter */}
        <Button
          themeColor={"primary"}
          className={`${course.status === "PUBLISHED" ? "hidden" : ""}`}
          onClick={() => {
            handleAddNewChapter();
          }}
        >
          {/* Add New Chapter */}
          {`${intl.formatMessage({
            id: "courses.generativeAi.generatedChapters.AddChapterButton",
          })}`}
        </Button>
      </div>
      <Error>{error.chapterName?.error}</Error>
      {makeChapterEditable &&
        course.chapters.map(
          (chapter) =>
            chapter.chapterId === editableChpt.chapterId && (
              <Dialog className="editChapter">
                <GeneratedChapterEdit
                  getIndex={(chptId: string) => {
                    return getChapterIndex(chptId);
                  }}
                  chapter={
                    course.chapters.find(
                      (ch) => ch.chapterId === editableChpt.chapterId
                    ) as CourseChapter
                  }
                  handleDelChapter={(chapter: CourseChapter) => {
                    setDelChptReq(true);
                    setOrgDelChpt(chapter);
                  }}
                  course={course}
                  duplicateS3File={(
                    sourceKey: string,
                    destinationKey: string,
                    fileType: string
                  ) => {
                    if (props.duplicateS3File) {
                      return props.duplicateS3File(
                        sourceKey,
                        destinationKey,
                        fileType
                      );
                    }
                  }}
                  handleVideoGeneration={(e: any) => {
                    console.log("Calling handleVideoGeneration", e);
                    if (props.handleVideoGeneration) {
                      return props.handleVideoGeneration(e);
                    }
                    console.warn("props.handleVideoGeneration is undefined");
                    return Promise.resolve(false);
                  }}
                  handleImageGeneration={(e: any) => {
                    console.log("Calling handleImageGeneration", e);
                    if (props.handleImageGeneration) {
                      return props.handleImageGeneration(e);
                    }
                    // The difference: This branch returns undefined, not a Promise<string | false>
                    // This causes a type error if the prop expects a function that always returns a Promise<string | false>
                    // To fix, always return a Promise:
                    return Promise.resolve(false);
                  }}
                  // handleAudioGeneration = {(e:any)=>{
                  //   console.log("Calling handleAudioGeneration",e);
                  //   if(props.handleAudioGeneration)
                  //   {
                  //     return props.handleAudioGeneration(e)
                  //   }
                  //   return Promise.resolve(false)
                  // }}

                  handleAudioGeneration={(e: any): Promise<{ presignedUrl: string; prompt: string } | false> => {
                    console.log("Calling handle audio generation ", e);
                    if (props.handleAudioGeneration) {
                      return props.handleAudioGeneration(e);
                    }
                    return Promise.resolve(false);
                  }}


                  handleUploadGiveUrl={(e: CourseModuleCards) => {
                    if (props.handleUploadGiveUrl) {
                      return props.handleUploadGiveUrl(e);
                    }
                  }}
                  handleUpdateChapter={(e: CourseChapter, isSave: boolean) =>
                    handleUpdateChapter(e, isSave)
                  }
                  videoGeneratingCardIds={
                    props.videoGeneratingCardIds ?? new Set<string>()
                  }
                  setVideoGeneratingCardIds={
                    props.setVideoGeneratingCardIds ?? (() => {})
                  }
                  handleCardTypeUpdate={(
                    cardId: string,
                    newCardType: string
                  ) => {
                    // This will be handled by the GeneratedChapterEdit component
                    console.log(
                      "Card type update requested:",
                      cardId,
                      newCardType
                    );
                  }}
                  handleFileTypeUpdate={(cardId: string, fileType: string) => {
                    console.log(
                      "File type update requested:",
                      cardId,
                      fileType
                    );
                  }}
                  specificCreateCourseFunction={
                    props.specificCreateCourseFunction
                  }
                  handleUpdateStatusAll={props.handleUpdateStatusAll}
                  // onQuickSaveSuccess= {()=>setQuickSaveDialog(true)}
                  onQuickSaveSuccess={(savedCourse: CourseModuleCards) => {
                    setCopyCourse(utils.deepCopy(savedCourse));
                    setQuickSaveDialog(true);
                  }}
                  copyCourse={copyCourse}
                />
              </Dialog>
            )
        )}

      <Sortable
        idField={"chapterId"}
        disabledField={"disabled"}
        data={courseChapters}
        itemUI={(e: SortableItemUIProps) => {
          let genChptProps = {
            ...e,
            enableDrag: enableDrag,
            makeEditable(chapter: CourseChapter) {
              setMakeChapterEditable(true);
              setEditableChpt(chapter);
              // Call the callback to trigger the useEffect in editCourse
              if (props.onCourseDetailsRefresh) {
                props.onCourseDetailsRefresh();
              }
            },
            getIndex(chptId: string) {
              return getChapterIndex(chptId);
            },
            handleEnableDrag(drag: boolean) {
              setEnableDrag(drag);
            },
            handleDuplicateChapter(chapterData: CourseChapter) {
              setDupChptReq(true);
              setOrgChptForDup(chapterData);
            },
            handleDelChapter(chapterData: CourseChapter) {
              setDelChptReq(true);
              setOrgDelChpt(chapterData);
            },
            status: course.status,
            cards: props.cards,
            courseName: props.cards.courseName,
            courseDescription: props.cards.description,
          };

          return GeneratedChapter(genChptProps);
        }}
        onNavigate={onNavigate}
        onDragOver={onDragOver}
      />
      {/* <div className="w-full flex justify-end items-center space-x-5"> */}
      <div className="w-full flex justify-end items-center gap-5">
        {props.testCourse ? (
          <Button
            themeColor="primary"
            onClick={() => {
              toggleTestCourseDialog();
            }}
            disabled={!props.isManual || hasEmptyUrl}
          >
            <FormattedMessage id="course.generateChapterCards.testCourse" />
          </Button>
        ) : (
          <></>
        )}

        <Button
          themeColor="primary"
          onClick={() => {
            console.log("This is the copyCourse", JSON.stringify(copyCourse));
            console.log("This is the orginal course", JSON.stringify(course));
            if (course.status === "PUBLISHED") {
              navigate("/courses");
            } else if (deepCopyCompareFunction()) {
              navigate("/courses");
            } else {
              console.log("inside else part");
              if (props.isCourse) {
                setformCourseDialog(true);
              } else {
                console.log("inside form dialog condition");
                setformDialog(true);
              }
            }
          }}
          disabled={!props.isManual && !clickQuickSave}
        >
          {`${intl.formatMessage({
            id: "backButton",
          })}`}
        </Button>
        {course.status === "PUBLISHED" && (
          <Button
            hidden={
              (props.tenantRole &&
                (props.tenantRole === "tnt_contentCreator" ||
                  props.tenantRole === "tnt_courseScheduler")) ||
              course.status !== "PUBLISHED"
                ? true
                : false
            }
            themeColor="primary"
            onClick={() => {
              if (course.status === "PUBLISHED") {
                toggleUnpublishDialog();
              }
            }}
          >
            <FormattedMessage id="courses.generatedChaptCards.unpublish" />
          </Button>
        )}
        {course.status !== "PUBLISHED" && (
          <>
            <Tooltip
              title={
                (!props.isManual && !clickQuickSave) || hasEmptyUrl
                  ? intl.formatMessage({
                      id: "courses.generateChaptersCards.aiVideoGenerationInProgress",
                    })
                  : ""
              }
              disableHoverListener={!hasEmptyUrl}
              placement="top"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "mk-primary-bright", // If using theme.palette['mk-primary']
                    color: "white", // Text color
                    fontSize: 13,
                    px: 1.5,
                    py: 0.5,
                    borderRadius: 1,
                  },
                },
                arrow: {
                  sx: {
                    color: "mk-primary-bright", // Arrow background to match tooltip
                  },
                },
              }}
            >
              <Box
                component="span"
                sx={{ display: "inline-block", marginRight: "-20px" }}
              >
                <Button
                  themeColor="primary"
                  hidden={course.status === "INREVIEW"}
                  onClick={() => {
                    setSubmitDialog(true);
                  }}
                  disabled={(!props.isManual && !clickQuickSave) || hasEmptyUrl}
                >
                  {`${intl.formatMessage({
                    id: "submitButton",
                  })}`}
                </Button>
              </Box>
            </Tooltip>

            <Button
              themeColor="primary"
              hidden={
                (props.tenantRole &&
                  (props.tenantRole === "tnt_contentCreator" ||
                    props.tenantRole === "tnt_courseScheduler")) ||
                course.status !== "INREVIEW"
                  ? true
                  : false
              }
              onClick={() => {
                setRejectDialog(true);
              }}
            >
              {`${intl.formatMessage({
                id: "courses.generateChaptersCards.reject",
              })}`}
            </Button>

            <Tooltip
              title={hasEmptyUrl ? "AI video generation is in progress" : ""}
              disableHoverListener={!hasEmptyUrl}
              placement="top"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "mk-primary-bright",
                    color: "white",
                    fontSize: 13,
                    px: 1.5,
                    py: 0.5,
                    borderRadius: 1,
                  },
                },
                arrow: {
                  sx: {
                    color: "mk-primary-bright",
                  },
                },
              }}
            >
              {/* <span style={{ display: "contents" }}> */}

              <Box component="span" sx={{ display: "inline-block" }}>
                <Button
                  themeColor="primary"
                  hidden={
                    (props.tenantRole &&
                      (props.tenantRole === "tnt_contentCreator" ||
                        props.tenantRole === "tnt_courseScheduler")) ||
                    course.status !== "INREVIEW"
                      ? true
                      : false
                  }
                  disabled={hasEmptyUrl}
                  onClick={() => {
                    setPublishDialog(true);
                  }}
                >
                  {`${intl.formatMessage({
                    id: "courses.generateChaptersCards.publish",
                  })}`}
                </Button>
              </Box>
            </Tooltip>

            <Button
              id="saveDraftButton"
              themeColor="primary"
              onClick={async () => {
                setClickQuickSave(true);
                console.log("save draft button clicked!");
                if (validate()) {
                  let dt = course;
                  dt.chapters.map((chpt) => {
                    delete chpt.newChapter;
                    chpt.cards.map((card) => {
                      delete card.cardInfo.card[0].tempUrl;
                    });
                  });

                  console.log("course id before save draft", dt?.courseId);
                  console.log("course before save draft", course);

                  if (props.specificCreateCourseFunction) {
                    if (props.handleUpdateStatusAll) {
                      if (course && course.status === "ARCHIVED") {
                        console.log("inside if of archived course");
                        props.handleUpdateStatusAll("DRAFT", course);
                      }
                    }

                    const saved = await props.specificCreateCourseFunction(
                      course
                    );
                    console.log("after quick save");

                    // console.log("props.clicksave value", props.clickSaveValue)
                    console.log("This is the quick save boolean flag", saved);
                    if (saved) {
                      setCopyCourse(utils.deepCopy(course));
                      setQuickSaveDialog(true);
                    } else {
                    }
                  }
                }
              }}
            >
              {`${intl.formatMessage({
                id: "courses.generateChaptersCards.quickSave",
              })}`}
            </Button>
          </>
        )}
        {/* // } */}
      </div>

      {/* Here onwards only dialogue divs */}

      {courseWarningDialogue && (
        <Dialog className="warningDialogue">
          <Alert
            // description="Please fill in the course name and description before proceeding to add a new chapter"
            description={`${intl.formatMessage({
              id: "courses.generateChaptersCards.chapterWarningDialogue",
            })}`}
            buttonText={`${intl.formatMessage({ id: "users.buttonText.Ok" })}`}
            icon={"warningShape.png"}
            iconMsg={intl.formatMessage({ id: "iconMsgWarning" })}
            backgroundColor={"mk-orange"}
            onClick={() => {
              setCourseWarningDialogue(false);
            }}
          />
        </Dialog>
      )}

      {dupChptReq && (
        <Dialog className="alertDialogue">
          <Confirm
            description={`${intl.formatMessage({ id: "chapter.duplicate" })} ${
              orgChptForDup.chapterName
            } ?`}
            successText={`${intl.formatMessage({ id: "chapter.success" })}`}
            failureText={`${intl.formatMessage({ id: "chapter.failure" })}`}
            icon={"alertShape.png"}
            iconMsg={`${intl.formatMessage({ id: "iconMsgAlert" })}`}
            backgroundColor={"mk-orange"}
            onSuccess={() => {
              handleDuplicateChapter(orgChptForDup);
              setDupChptReq(false);
            }}
            onFailure={() => {
              setDupChptReq(false);
            }}
          />
        </Dialog>
      )}

      {delChptReq && (
        <Dialog className="alertDialogue">
          <Confirm
            description={`${intl.formatMessage({ id: "chapter.delete" })} ${
              orgDelChpt.chapterName
            } ?`}
            successText={`${intl.formatMessage({ id: "chapter.success" })}`}
            failureText={`${intl.formatMessage({ id: "chapter.failure" })}`}
            icon={"alertShape.png"}
            iconMsg={`${intl.formatMessage({ id: "iconMsgAlert" })}`}
            backgroundColor={"mk-orange"}
            onSuccess={() => {
              handleDeleteChapter(orgDelChpt.chapterId);
              setDelChptReq(false);
            }}
            onFailure={() => {
              setDelChptReq(false);
            }}
          />
        </Dialog>
      )}
      {testCourseDialog && (
        <Dialog className="requireTestCourseDialogue">
          <TestCourseDialog
            component={() => (
              <props.testCourse
                testCourseDialogToggle={setTestCourseDialog}
                testCourseDialogValue={testCourseDialog}
                courseIdValue={course.courseId}
              ></props.testCourse>
            )}
          ></TestCourseDialog>
        </Dialog>
      )}

      {submitDialog && (
        <Dialog className="alertDialogue">
          <Confirm
            description={intl.formatMessage({ id: "course.submitCourse" })}
            successText={intl.formatMessage({
              id: "users.cohortList.deletionSuccess",
            })}
            failureText={intl.formatMessage({
              id: "users.cohortList.deletionFailure",
            })}
            icon="alertShape.png"
            iconMsg={intl.formatMessage({ id: "iconMsgAlert" })}
            backgroundColor="mk-orange"
            onSuccess={async () => {
              setSubmitDialog(false);

              if (!props.handleUpdateStatusAll) {
                return;
              }

              const shouldValidateFirst =
                props.isManual && !deepCopyCompareFunction();
              const shouldSubmitDirectly =
                (props.isManual && deepCopyCompareFunction()) || clickQuickSave;

              if (shouldValidateFirst) {
                const validated = await validateAndSubmit();
                if (!validated) {
                  return;
                }
              }

              if (shouldValidateFirst || shouldSubmitDirectly) {
                const saved = await props.handleUpdateStatusAll(
                  "INREVIEW",
                  course
                );
                if (saved) {
                  setSuccessSubmitDialog(true);
                }
              }
            }}
            onFailure={() => {
              setSubmitDialog(false);
            }}
          />
        </Dialog>
      )}

      {successSubmitDialog && (
        <Dialog className="confirmSuccessDialogue">
          <Alert
            description={`${intl.formatMessage({
              id: "course.submitCourseSuccess",
            })}`}
            buttonText={`${intl.formatMessage({ id: "users.buttonText.Ok" })}`}
            icon={"successShape.png"}
            iconMsg={`${intl.formatMessage({ id: "iconMsgSuccess" })}`}
            backgroundColor={"mk-bright-green"}
            onClick={() => {
              console.log("in success submit dialog print");
              setSuccessSubmitDialog(false);
              navigate("/courses");
            }}
          />
        </Dialog>
      )}
      {formDialog && (
        <Dialog className="alertDialogue">
          <Confirm
            description={intl.formatMessage({ id: "course.saveChanges" })}
            successText={intl.formatMessage({
              id: "users.cohortList.deletionSuccess",
            })}
            failureText={intl.formatMessage({
              id: "users.cohortList.deletionFailure",
            })}
            icon="alertShape.png"
            iconMsg={intl.formatMessage({ id: "iconMsgAlert" })}
            backgroundColor="mk-orange"
            onSuccess={async () => {
              if (
                props.handleUpdateStatusAll &&
                course?.status === "ARCHIVED"
              ) {
                await props.handleUpdateStatusAll("DRAFT", course);
              }

              setformDialog(false);

              if (!validate()) {
                return;
              }

              const courseWithoutTempData = {
                ...course,
                chapters: course.chapters.map((chapter) => ({
                  ...chapter,
                  newChapter: undefined,
                  cards: chapter.cards.map((card) => ({
                    ...card,
                    cardInfo: {
                      ...card.cardInfo,
                      card: card.cardInfo.card.map((c) => ({
                        ...c,
                        tempUrl: undefined,
                      })),
                    },
                  })),
                })),
              };

              if (props.specificCreateCourseFunction) {
                const saved = await props.specificCreateCourseFunction(
                  courseWithoutTempData
                );
                if (saved) {
                  setCopyCourse(utils.deepCopy(course));
                  navigate("/courses");
                }
              }
            }}
            onFailure={() => {
              setformDialog(false);
              navigate("/courses");
            }}
          />
        </Dialog>
      )}

      {formCourseDialog && (
        <Dialog className="alertDialogue">
          <Confirm
            description={intl.formatMessage({ id: "course.saveChanges" })}
            successText={intl.formatMessage({
              id: "users.cohortList.deletionSuccess",
            })}
            failureText={intl.formatMessage({
              id: "users.cohortList.deletionFailure",
            })}
            icon="alertShape.png"
            iconMsg={intl.formatMessage({ id: "iconMsgAlert" })}
            backgroundColor="mk-orange"
            onSuccess={async () => {
              if (
                props.handleUpdateStatusAll &&
                course?.status === "ARCHIVED"
              ) {
                await props.handleUpdateStatusAll("DRAFT", course);
              }

              setformCourseDialog(false);

              if (!validate()) {
                return;
              }

              const courseWithoutTempData = {
                ...course,
                chapters: course.chapters.map((chapter) => ({
                  ...chapter,
                  newChapter: undefined,
                  cards: chapter.cards.map((card) => ({
                    ...card,
                    cardInfo: {
                      ...card.cardInfo,
                      card: card.cardInfo.card.map((c) => ({
                        ...c,
                        tempUrl: undefined,
                      })),
                    },
                  })),
                })),
              };

              if (props.specificCreateCourseFunction) {
                const saved = await props.specificCreateCourseFunction(
                  courseWithoutTempData
                );
                if (saved) {
                  setCopyCourse(utils.deepCopy(course));
                  navigate("/courses");
                }
              }
            }}
            onFailure={() => {
              setformCourseDialog(false);
              navigate("/courses");
            }}
          />
        </Dialog>
      )}
      {quickSaveDialog && (
        <Dialog className="confirmSuccessDialogue">
          <Alert
            description={`${intl.formatMessage({
              id: "course.saveChangesSuccess",
            })}`}
            buttonText={`${intl.formatMessage({ id: "users.buttonText.Ok" })}`}
            icon={"successShape.png"}
            iconMsg={`${intl.formatMessage({ id: "iconMsgSuccess" })}`}
            backgroundColor={"mk-bright-green"}
            onClick={() => {
              setQuickSaveDialog(false);
            }}
          />
        </Dialog>
      )}

      {publishDialog && (
        <Dialog className="alertDialogue">
          <Confirm
            description={intl.formatMessage({ id: "course.publishCourse" })}
            successText={intl.formatMessage({
              id: "users.cohortList.deletionSuccess",
            })}
            failureText={intl.formatMessage({
              id: "users.cohortList.deletionFailure",
            })}
            icon="alertShape.png"
            iconMsg={intl.formatMessage({ id: "iconMsgAlert" })}
            backgroundColor="mk-orange"
            onSuccess={async () => {
              setPublishDialog(false);

              if (!props.handleUpdateStatusRev || !props.isManual) {
                return;
              }

              const shouldValidate = !deepCopyCompareFunction();

              if (shouldValidate) {
                const validated = await validateAndSubmit();
                if (!validated) return;
              }

              const saved = await props.handleUpdateStatusRev(
                "PUBLISHED",
                course
              );
              if (saved) {
                setSuccessPublishDialog(true);
              }
            }}
            onFailure={() => setPublishDialog(false)}
          />
        </Dialog>
      )}

      {successPublishDialog && (
        <Dialog className="confirmSuccessDialogue">
          <Alert
            description={`${intl.formatMessage({
              id: "course.publishCourseSuccess",
            })}`}
            buttonText={`${intl.formatMessage({ id: "users.buttonText.Ok" })}`}
            icon={"successShape.png"}
            iconMsg={`${intl.formatMessage({ id: "iconMsgSuccess" })}`}
            backgroundColor={"mk-bright-green"}
            onClick={() => {
              setSuccessPublishDialog(false);
              navigate("/courses");
            }}
          />
        </Dialog>
      )}

      {rejectDialog && (
        <Dialog className="alertDialogue">
          <Confirm
            description={`${intl.formatMessage({ id: "course.rejectCourse" })}`}
            successText={`${intl.formatMessage({
              id: "users.cohortList.deletionSuccess",
            })}`}
            failureText={`${intl.formatMessage({
              id: "users.cohortList.deletionFailure",
            })}`}
            icon={"alertShape.png"}
            iconMsg={`${intl.formatMessage({ id: "iconMsgAlert" })}`}
            backgroundColor={"mk-orange"}
            onSuccess={async () => {
              setRejectDialog(false);
              console.log(
                "copy course before publish",
                JSON.stringify(copyCourse)
              );
              console.log(
                "original course before publish",
                JSON.stringify(course)
              );
              if (props.handleUpdateStatusRev) {
                if (props.isManual && !deepCopyCompareFunction()) {
                  console.log("I entered reject if");
                  const validated = await validateAndSubmit();
                  if (validated) {
                    const saved = await props.handleUpdateStatusRev(
                      "DRAFT",
                      course
                    );

                    if (saved) {
                      setSuccessRejectDialog(true);
                    }
                  }
                } else if (props.isManual && deepCopyCompareFunction()) {
                  console.log("I entered reject else if");
                  const saved = await props.handleUpdateStatusRev(
                    "DRAFT",
                    course
                  );

                  if (saved) {
                    setSuccessRejectDialog(true);
                  }
                }
              }
            }}
            onFailure={() => {
              setRejectDialog(false);
            }}
          />
        </Dialog>
      )}

      {successRejectDialog && (
        <Dialog className="confirmSuccessDialogue">
          <Alert
            description={`${intl.formatMessage({
              id: "course.rejectCourseSuccess",
            })}`}
            buttonText={`${intl.formatMessage({ id: "users.buttonText.Ok" })}`}
            icon={"successShape.png"}
            iconMsg={`${intl.formatMessage({ id: "iconMsgSuccess" })}`}
            backgroundColor={"mk-bright-green"}
            onClick={() => {
              setSuccessRejectDialog(false);
              navigate("/courses");
            }}
          />
        </Dialog>
      )}
      {unpublishDialog && (
        <Dialog className="alertDialogue">
          <Confirm
            description={intl.formatMessage({
              id: "courses.generateChaptersCards.unpublishAlert",
            })}
            successText={intl.formatMessage({ id: "chapter.success" })}
            failureText={intl.formatMessage({ id: "chapter.failure" })}
            icon={"alertShape.png"}
            iconMsg={`${intl.formatMessage({ id: "iconMsgAlert" })}`}
            backgroundColor={"mk-orange"}
            onSuccess={async () => {
              toggleUnpublishDialog();
              if (props.handleUpdateStatusRev) {
                const saved = await props.handleUpdateStatusRev(
                  "DRAFT",
                  course,
                  true
                );

                if (saved) {
                  setUnpublishSuccessDialog(true);
                }
                // props.handleUpdateStatusRev("DRAFT", course, true);
              }
            }}
            onFailure={() => {
              toggleUnpublishDialog();
            }}
          />
        </Dialog>
      )}
      {unpublishSuccessDialog && (
        <Dialog className="confirmSuccessDialogue">
          <Alert
            description={intl.formatMessage({
              id: "courses.generatedChaptCards.unpublishSuccess",
            })}
            buttonText={`${intl.formatMessage({ id: "users.buttonText.Ok" })}`}
            icon={"successShape.png"}
            iconMsg={`${intl.formatMessage({ id: "iconMsgSuccess" })}`}
            backgroundColor={"mk-bright-green"}
            onClick={() => {
              setUnpublishSuccessDialog(false);
              navigate("/courses");
            }}
          />
        </Dialog>
      )}
    </div>
  );
}
